import { render, staticRenderFns } from "./SellersTable.vue?vue&type=template&id=077fa42a&scoped=true&"
import script from "./SellersTable.vue?vue&type=script&lang=js&"
export * from "./SellersTable.vue?vue&type=script&lang=js&"
import style0 from "./SellersTable.vue?vue&type=style&index=0&id=077fa42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077fa42a",
  null
  
)

export default component.exports